/**
 * Account API Client
 * Frontend API calls for authenticated account management actions.
 */

import { apiCall } from '../api';
import type { ChangePasswordRequest, MessageResponse } from '@/types/api';

/**
 * Update the authenticated member's password.
 */
export async function changeMyPassword(
  data: ChangePasswordRequest
): Promise<MessageResponse> {
  return await apiCall<MessageResponse>('/api/auth/me/password', {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}
